import { FC } from 'react';

interface ChecklistYesNoProps {
  label: string;
  description?: string | null;
  isRequired?: boolean;
  value: boolean | null;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  helperText?: string | null;
  onClear?: () => void;
}

const ChecklistYesNo: FC<ChecklistYesNoProps> = ({
  label,
  description,
  isRequired,
  value,
  onChange,
  disabled,
  helperText,
  onClear,
}) => {
  const handleSelect = (next: boolean) => {
    if (disabled) {
      return;
    }

    onChange(next);
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="">
        <div className="flex items-start justify-between gap-2">
          <div>
            <p className="text-sm font-semibold text-slate-800">
              {label}
              {isRequired ? <span className="ml-1 text-danger">*</span> : null}
            </p>
            {description ? <p className="mt-1 text-xs text-slate-500">{description}</p> : null}
          </div>
          {value !== null && onClear ? (
            <button
              type="button"
              className="text-[11px] font-medium text-slate-400 underline-offset-2 hover:text-slate-600 hover:underline disabled:opacity-50"
              onClick={onClear}
              disabled={disabled}
            >
              Clear
            </button>
          ) : null}
        </div>
        <div className="flex gap-2 mt-2">
          <button
            type="button"
            className={`inline-flex items-center justify-center rounded-lg px-3 py-1.5 text-xs font-semibold transition ${
              value === true
                ? 'bg-primary text-white shadow-sm shadow-emerald-200'
                : 'border border-slate-200 text-slate-600 hover:border-emerald-300 hover:text-emerald-600'
            } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
            onClick={() => handleSelect(true)}
            disabled={disabled}
          >
            Yes
          </button>
          <button
            type="button"
            className={`inline-flex items-center justify-center rounded-lg px-3 py-1.5 text-xs font-semibold transition ${
              value === false
              ? 'bg-primary text-white shadow-sm shadow-rose-200'
                : 'border border-slate-200 text-slate-600 hover:border-rose-300 hover:text-rose-600'
            } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
            onClick={() => handleSelect(false)}
            disabled={disabled}
          >
            No
          </button>
        </div>
      </div>
      {helperText ? <p className="mt-2 text-xs text-slate-400">{helperText}</p> : null}
    </div>
  );
};

export default ChecklistYesNo;
